import { type ReactNode } from 'react'

interface Props {
  icon?: ReactNode
  title: string
  description?: string
  action?: ReactNode
}

export function EmptyState({ icon, title, description, action }: Props) {
  return (
    <div className="flex flex-col items-center justify-center text-center px-5 py-14 animate-fade-in">
      {icon && (
        <div className="mb-5 text-ember/60 text-3xl">
          {icon}
        </div>
      )}
      <h3 className="font-display text-xl text-cream mb-2">{title}</h3>
      {description && (
        <p className="text-sm text-mute max-w-sm mb-7 leading-relaxed">{description}</p>
      )}
      {action}
    </div>
  )
}
